module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAAKCAYAAAC5Sw6hAAAAAXNSR0IArs4c6QAAAMRJREFUKFOd0s8OwUAQBvBvODp5OweVkrp2NzyBByAzeyUIfT6Jg2ONrLRNVbcVe5w/v+yXDKHjiUgEYFeMrIwx19A4hRrOuYWqHgCUM0pESZqmx7adVkhE5gA8MmgsPQEkxphTE/uCCmQPYBj4bQ5g2cQ+IOdcXMQJIaWdFzHPZaGCmHlGRD5/H1Jhqrqw1l584Q0x85SIvP4rUsdia21GIjIBkP2B1GNGHroBGHfdU19PVe/EzBsiWgMY9S0E+g9V3b4ArbxG6wq+ovEAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/product/tree-close-icon.png
// module id = Lf5j
// module chunks = 1